export enum Skin {
    day,
    night
}